export const SET_ACTIVE_ACTION = 'actionBar/SET_ACTIVE_ACTION';
export const RESET_ACTIVE_ACTION = 'actionBar/RESET_ACTIVE_ACTION';
export const SET_DISABLE_FOR_ACTION = 'actionBar/SET_DISABLE_FOR_ACTION';
